import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'UniformSysConfig'
};

const methods = [
    'AddConfigSys',
    'UpdateConfigSys',
    'DelConfigSys',
    'GetSysById',
    'GetConfigSysMangePagingList',
    'FindAll',
    'InitSysConfig'  
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const UniformSysConfigApi = ZJApi.defineNewApi('UniformSysConfigApi', factory);

export default UniformSysConfigApi;